
export enum Event {
    updateGaugeMetrics = 'updateGaugeMetrics',
    updateDurationColumns = 'updateDurationColumns',
    updateVariantsGrid = 'updateVariantsGrid',
    updateStepSlicerVariantChart = 'updateStepSlicerVariantChart',
    updatePathSlicerVariantChart = 'updatePathSlicerVariantChart',
    updateVariantSlicerVariantChart = 'updateVariantSlicerVariantChart',
    updateActivitySlicerVariantChart = 'updateActivitySlicerVariantChart',
    StepVisualGridUpdate = 'StepVisualGridUpdate',
    VariantVisualGridUpdate = 'VariantVisualGridUpdate',
    ActivitiesVisualGridUpdate = 'ActivitiesVisualGridUpdate',
    updateDataTransformation = 'updateDataTransformation',
    openSettings = 'openSettings',
    openFilterActivity = 'openFilterActivity',
    openFilterStep = 'openFilterStep',
    openAnalytics = 'openAnalytics',
    setActionBar_Dashboard = 'setActionBar_Dashboard',
    setActionBar_Consultant = 'setActionBar_Consultant',
    setActionBar_Visualizer = 'setActionBar_Visualizer',
    setActionBar_Cluster = 'setActionBar_Cluster',
    setActionBar_Costs = 'setActionBar_Costs',
    setActionBar_Model = 'setActionBar_Model',
    updateDashboard = 'updateDashboard',
    setActionBar_Workflow = 'setActionBar_Workflow',
    setActionBar_InfluenceAnalysis = 'setActionBar_InfluenceAnalysis',
    setActionBar_DecompositionTree = 'setActionBar_DecompositionTree',
    setActionBar_Analytics = 'setActionBar_Analytics',
    setActionBar_DiscoveryRulesSummary = 'setActionBar_DiscoveryRulesSummary',
    setActionBar_DiscoveryRulesVisualizer = 'setActionBar_DiscoveryRulesVisualizer',
    setActionBar_Findings = 'setActionBar_Findings',
    setActionBar_FindingsSummary = 'setActionBar_FindingsSummary',
    setActionBar_FindingsVisualizer = 'setActionBar_FindingsVisualizer',
    setActionBar_Time = 'setActionBar_Time',
    setDiagramWidth = 'setDiagramWidth',
    setTopXVariants = 'setTopXVariants',
    updateTaskHistogram = 'updateTaskHistogram',
    openVariantLifecycleModal = 'openVariantLifecycleModal',
    openProgressModal = 'openProgressModal',
    saveModal = 'saveModal',
    openAnalyticModal = 'openAnalyticModal',
    closeProgressModal = 'closeProgressModal',
    openLifecycleModalMulti = 'openLifecycleModalMulti',
    openLifecycleModalSingle = 'openLifecycleModalSingle',
    showSpinner = 'showSpinner',
    downloadDiscoveryRule = 'downloadDiscoveryRule',
    downloadFinding = 'downloadFinding',
    hideSpinner = 'hideSpinner',
    setMaxWidth = 'setMaxWidth',
    setVariableWidth = 'setVariableWidth',
    updateTimeInActivity = 'updateTimeInActivity',
    openTipsModal = 'openTipsModal',
    setTimeDefaults = 'setTimeDefaults',
    openDiscoveryRules = 'openDiscoveryRules',
    processDiscoveryRule='processDiscoveryRule',
    processFinding='processFinding',
    saveModel='saveModel',
    updateCost='updateCost',
    updateDiscoveryRules='updateDiscoveryRules',
    updateFindings='updateFindings',
    updateFindingDetail='updateFindingDetail',
    updateAnalytic = 'updateAnalytic',
    updateDiscoveryRuleDetail = 'updateDiscoveryRuleDetail',

    
    updateTasksFilterVariablesLimits = 'updateTasksFilterVariablesLimits',
    resetTasksFilter = 'resetTasksFilter',
    resetTimeFilter = 'resetTimeFilter',
    resetAttributeFilter = 'resetAttributeFilter',
    visualizerSettingsAlert = 'visualizerSettingsAlert',
    loadProcessMinerSettings = 'loadProcessMinerSettings',
    resetVisualizerSettings = 'resetVisualizerSettings',
    applyFilter = 'applyFilter',
    filterIconActive = 'filterIconActive',
    discoveryIconActive = 'discoveryIconActive',
    resetIcons = 'resetIcons',

    resetEventLog = 'resetEventLog',
    resetFilter = 'resetFilter',
    resetDiscovery = 'resetDiscovery',
    resetComments = 'resetComments',
    updateComments = 'updateComments',
    updateTasks = 'updateTasks',
    updateEvents = 'updateEvents',
    updateFilterAttributes = 'updateFilterAttributes',

    setAnalyticsTab = 'setAnalyticsTab',
    
    showContextMenu = 'showContextMenu',
    hideContextMenu = 'hideContextMenu',

    openDiscoveryRuleModal = 'openDiscoveryRuleModal',
    openFindingModal = 'openFindingModal',
    openStepCostModal = 'openStepCostModal',
    openStepMetricsModal = 'openStepMetricsModal',

    openCommentsModal = 'openCommentsModal',
    openActivityStepAnalysisModal = 'openActivityStepAnalysisModal',
    openProcessAnalyticsModal = 'openProcessAnalyticsModal',
    openStepAnalyticsModal = 'openStepAnalyticsModal',
    openHistogramModal = 'openHistogramModal',
    openWorkflowModal = 'openWorkflowModal',
    openTaskDetailModal = 'openTaskDetailModal',
    openEventDetailModal = 'openEventDetailModal',

    changeActivePane = 'changeActivePane',
    resizeSidebar = 'resizeSidebar',

    updateTaskAttributes = 'updateTaskAttributes',
    updateEventAttributes = 'updateEventAttributes',
    updateCurrentFilters = 'updateCurrentFilters',

    automationDiscoveryRulesAlert = 'automationDiscoveryRulesAlert',
    performanceDiscoveryRulesAlert = 'performanceDiscoveryRulesAlert',
    variantFilterAlert = 'variantFilterAlert',
    taskConstraintAlert = 'taskConstraintAlert',
    discoveryConstraintAlert = 'taskConstraintAlert',
    pathFilterAlert = 'pathFilterAlert',
    stepFilterAlert = 'stepFilterAlert',
    activityFilterAlert = 'activityFilterAlert',
    attributeFilterAlert = 'attributeFilterAlert',
    timeFilterAlert = 'timeFilterAlert',
    discoveryRuleIconActive = 'discoveryRuleIconActive',    updateMetricSettings = 'updateMetricSettings',
    dataImportComplete = 'dataImportComplete',
    importDiscoveryRules = 'importDiscoveryRules',
    uploadFileAlert = 'uploadFileAlert',

    changeVisualizerBackgroundColor = 'changeVisualizerBackgroundColor',

    setDiscoveryExpanded = 'setDiscoveryExpanded',
    setFilterExpanded = 'setFilterExpanded',
    setVariantPane = 'SetVariantPane',
    displayVisualizer = 'displayVisualizer',
    applyClusterMetricFilter = 'applyClusterMetricFilter' ,
    applyDecompositionTreeMetricFilter = 'applyDecompositionTreeMetricFilter' ,
    applyInfluenceAnalysisMetricFilter = 'applyInfluenceAnalysisMetricFilter' ,
    setDiagramDecompositionTree = 'setDiagramDecompositionTree',
    setDiagramInfluenceAnalysis = 'setDiagramInfluenceAnalysis',
    setDiagramCluster = 'setDiagramCluster',
    changeHighlight = 'changeHighlight',
    changeStepColour = 'changeStepColour',
    updateGaugeCompliance = 'updateGaugeCompliance',
    updateGaugeAutomation = 'updateGaugeAutomation',
    updateGaugePerformance = 'updateGaugePerformance',
    updateGauge = '',
    updateHistogram = 'updateHistogram',
    updateLoadingStatus = 'updateLoadingStatus',
    updateProgressModal = 'updateProgressModal',
    closePM = 'closePM'
}

export type Events = {
    [key in keyof typeof Event]?: (value: any) => any
}
